import { UserBasicInformation } from "../users/user-basic-information";
import { AcademicFilterComponent } from './../../templates/academic-filter/academic-filter.component';

export class AcademicFilter {
  classId?: number;
  sectionId?: number;
  assmentCategoryId:number;
  className: string;
  sectionName: string;
  classNameEn: string;
  sectionNameEn: string;
  studentId?: string;
  sectionSubjectId?: number;
  sectionSubjectName?: string;
  sectionSubjectNameEn?: string;
  studentIds?:string[]=[];
  selectedStudents?: UserBasicInformation[] = [];
  component?: AcademicFilterComponent;
}
